export default "__VITE_ASSET__2ed7ffab__"